import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { blueGrey } from "vuetify/util/colors";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import "vuetify/dist/vuetify.js";
import { VFileUpload } from "vuetify/labs/VFileUpload";
import "@/assets/styles/global.scss";

export default createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  components: {
    ...components,
    VFileUpload,
  },
  directives,
  theme: {
    defaultTheme: "tunnl",
    variations: {
      colors: [
        "primary",
        "secondary",
        "tertiary",
        "prominent",
        "emphasis",
        "accent",
        "background",
        "background-gray",
        "highlight",
        "action",
        "anchor",
      ],
      lighten: 5,
      darken: 4,
    },
    themes: {
      tunnl: {
        dark: false,
        colors: {
          primary: "#2a2c99", // blue
          secondary: "#36b779", // green
          tertiary: "#1a7183", // teal
          prominent: "#54585a", // dark grey
          emphasis: "#2a2c99", // blue
          accent: "#00a2db", // light blue
          background: "#ffffff", // white
          "background-blue-grey": blueGrey.lighten5,
          "background-gray": "#f3f6f8", //gray-blue
          highlight: "#ffffff", // white
          action: "#36b779", // green
          anchor: "#2a2c99", // blue
        },
      },
      deeproot: {
        dark: false,
        colors: {
          primary: "#3fae29", // green
          secondary: "#585858", // grey
          tertiary: "#0074c8", // blue
          prominent: "#585858", // dark grey
          emphasis: "#585858", // dark grey
          accent: "#97d4e9", // light blue
          background: "#fff", // white
          "background-blue-grey": blueGrey.lighten5,
          "background-gray": "#f2f2f2", //light gray
          highlight: "#585858", // dark grey
          action: "#3fae29", // green
          anchor: "#0074c8", // blue
        },
      },
    },
  },
});
